import { render, staticRenderFns } from "./DCConfirm.vue?vue&type=template&id=b22dee36&"
import script from "./DCConfirm.vue?vue&type=script&lang=js&"
export * from "./DCConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports